module.exports = __webpack_public_path__ + "img/Support-skill-134.9af378ca.png";